import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useGlossaryDefinitionHttp } from '@/core/api/glossary-definitions'
import { GlossaryDefinition, GlossaryDefinitionPayload } from '@/core/models/glossary-definition'

export type GlossaryDefinitionCollection = {
    data: Array<GlossaryDefinition>,
    meta?: MetaPayload,
    links?: any
}

const state: GlossaryDefinitionCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const glossaryDefinitionCollection: Module<GlossaryDefinitionCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: GlossaryDefinitionCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: GlossaryDefinitionPayload) => {
                state.data.push(new GlossaryDefinition(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useGlossaryDefinitionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: GlossaryDefinitionCollection): GlossaryDefinitionCollection => {
            return state
        }
    }
}